import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
  { code: 'fr', label: 'FR' },
  { code: 'es', label: 'ES' },
  { code: 'pt', label: 'PT' }
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);

    if (location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/sign-')) {
      return;
    }

    const pathParts = location.pathname.split('/').filter(Boolean);
    const existingLangMatch = pathParts.length > 0 && ['pt', 'es', 'fr', 'de'].includes(pathParts[0]);

    const cleanPath = existingLangMatch ? pathParts.slice(1).join('/') : pathParts.join('/');
    
    let nextPath = '/';
    if (langCode === 'en') {
      nextPath = cleanPath ? `/${cleanPath}` : '/';
    } else {
      nextPath = cleanPath ? `/${langCode}/${cleanPath}` : `/${langCode}`;
    }

    if (location.hash) {
      nextPath += location.hash;
    }
    
    navigate(nextPath, { replace: true });
  };

  return (
    <div className="lang-switcher">
      <Globe size={14} className="lang-icon" />
      <div className="lang-pills">
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`lang-pill ${i18n.language === lang.code ? 'active' : ''}`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}
